import { Box, Modal } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

import PersonPropType from "src/custom-prop-types/person";

import PersonMembershipsPanel from "./PersonMembershipsPanel";
import ModalHeader from "./ModalHeader";

const PersonAllocationsModal = ({
  isVisible,
  person,
  groupTypes,
  onHideModal,
  currentGroup,
  forceUpdatePerson = false,
  showAlreadyAllocatedNotification,
  teamToAdd,
  teamToAddError,
}) => {
  if (!isVisible || !person) {
    return null;
  }

  const layoutFunction = (modalBody, viewToggle) => (
    <Modal
      data-testid="cp-allocation-modal"
      visible={isVisible}
      maxWidth="90vw"
      maxHeight="90vh"
      height={["90vh", "90vh", "90vh", "90vh", "80vh"]}
      width={["90vw", "90vw", "90vw", "90vw", "90vw", "80vw"]}
      onClose={onHideModal}
      headerContent={
        <ModalHeader
          person={person}
          showAlreadyAllocatedNotification={showAlreadyAllocatedNotification}
          viewToggle={viewToggle}
        />
      }
    >
      <Box px="xs">{modalBody}</Box>
    </Modal>
  );

  return (
    <PersonMembershipsPanel
      person={person}
      currentGroup={currentGroup}
      groupTypes={groupTypes}
      layoutFunction={layoutFunction}
      forceUpdatePerson={forceUpdatePerson}
      teamToAdd={teamToAdd}
      teamToAddError={teamToAddError}
    />
  );
};

PersonAllocationsModal.propTypes = {
  isVisible: PropTypes.bool,
  person: PersonPropType.isRequired,
  groupTypes: PropTypes.object.isRequired,
  onHideModal: PropTypes.func,
  currentGroup: PropTypes.object,
  forceUpdatePerson: PropTypes.bool,
  showAlreadyAllocatedNotification: PropTypes.bool,
  teamToAdd: PropTypes.object,
  teamToAddError: PropTypes.object,
};

export default React.memo(PersonAllocationsModal);
